import React, { Component } from 'react';

import Means from './Means';
import Reasons from './Reasons';
import Destinations from './Destinations';
import MobilityWork from './MobilityWork';
import MobilityHome from './MobilityHome';
import BikePotential from './BikePotential';
import DestinationsWork from './DestinationsWork';
import Zones from './Zones';
import FlowsOD from './FlowsOD';
import FlowsOD_Outside from './FlowsOD_Outside';

import Sources from '../f-Utilities/Sources'
import Info from '../f-Utilities/Info'

import PlotPie from '../c-PlotlyFigures/PlotPie';

class MobilityProfile extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      selected_focus: "focus_work"
    }
  }

  setFocus = (focus) => {
    this.setState({selected_focus: focus})
  }

  render() {

    function label_text(status){
      var total = Object.values(status).reduce((a,b) => a + b);
      var text = Object.fromEntries(
                  Object.entries(status).map(
                    ([k, v], i) => [k, "<span style='font-size: 1.5vw;'>" + Math.round(v/total*1000)/10 +
                                      " %</span></br></br><span style='font-weight: 300;'>" + k + "</span>" ]
                  )
                );
      return(Object.values(text))
    }

    function hover_text(status){
      var text = Object.fromEntries(
                  Object.entries(status).map(
                    ([k, v], i) => [k, k + "</br></br><span style='font-weight: 300;'>" + Math.round(v) + " déplacements</span>"]
                  )
                );
      return(Object.values(text))
    }

    var territory = this.props.territory;
    return(
      <div className="row">
        <div className="col">

          <div className="row justify-content-between mb-5">
            <div className="col-3">
              <p className="mb-3">On quantifie ici les déplacements de la population du territoire, un jour de semaine moyen.
              {Object.keys(this.props.territory.sources).includes("emd") && <Info content="Il s'agit des déplacements de la population de 5 ans et plus."/>}</p>
              <p><span className="key_figure">{territory.all_travels.total.number.toLocaleString("fr-FR")}</span> déplacements/jour</p>
              <p>→ <b>{territory.all_travels.total_nb_per_pers}</b> déplacements/jour/personne mobile</p>
              <p>→ <b>{territory.all_travels.total_dist_per_pers}</b> km/jour/personne mobile</p>
              <p className="mb-3">→ <b>{territory.all_travels.total_duration_per_pers}</b> min/jour/personne mobile</p>

              {Object.keys(this.props.territory.sources).includes("emd") ?
              <Sources sources={this.props.territory.sources}
                     concerned={["emd"]}/> :
               <Sources sources={this.props.territory.sources}
                      concerned={["entd", "census", "mobpro", "bpe"]} processed={true}/>
              }
            </div>
            <div className="col-4">
              <Means territory={territory} />
            </div>
            <div className="col-4">
              <Reasons territory={territory} />
            </div>
          </div>

          {/*<div className="row mb-5">
            <div className="col-12">
              <Destinations territory={territory} id="destinations" />
            </div>
          </div>*/}

          <Zones territory={territory} id="zones" />

          <FlowsOD territory={territory} id="all_flows_od"/>

          {/*<FlowsOD_Outside territory={territory} id="all_flows_od_outside"/>*/}

          <div className="row mt-5 mb-4">
            <div className="col">
                <div className="row">
                  <div className="col-auto">
                    <h3 onClick={this.setFocus.bind(this, "focus_work")}
                        className={this.state.selected_focus == "focus_work" ? "mb-0 pb-1 nav selected" : "mb-0 pb-1 nav"}>FOCUS SUR LES TRAJETS TRAVAIL</h3>
                  </div>
                  <div className="col-auto">
                    <h3 onClick={this.setFocus.bind(this, "focus_home")}
                        className={this.state.selected_focus == "focus_home" ? "mb-0 pb-1 nav selected" : "mb-0 pb-1 nav"}>FOCUS SUR LES TRAJETS DOMICILE</h3>
                  </div>
                </div>
            </div>
          </div>

          {this.state.selected_focus == "focus_home" ?
              <MobilityHome territory={territory} /> :
              <MobilityWork territory={territory} />}


        {this.props.territory.work_travels_flows != null &&
          <div className="row mb-5">
            <div className="col-12">
              <h3>destinations - motif travail</h3>
               <DestinationsWork territory={territory}  id="destinations_work"/>
            </div>
          </div>
        }




        </div>
      </div>
    )
  }
}

export default MobilityProfile;
